import { ArrowRight } from "lucide-react";
import { MaskedLine } from "@/components/MaskedLine";
import { Reveal } from "@/components/Reveal";
import { useSectionNav } from "@/lib/scroll";

export const FinalCTA = () => {
  const go = useSectionNav();

  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden py-32 lg:py-48 px-5 sm:px-8"
    >
      <div
        className="absolute top-1/2 -left-1/4 w-[150%] h-px -translate-y-1/2 rotate-[-14deg] bg-gradient-to-r from-transparent via-white/20 to-transparent pointer-events-none"
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto">
        <Reveal>
          <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-8">
            Let's build something great
          </p>
        </Reveal>
        <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.06]">
          <MaskedLine className="pb-1" innerClassName="text-neutral-50">
            Your vision. Our design.
          </MaskedLine>
          <MaskedLine className="pb-1" innerClassName="text-neutral-50" delay={0.12}>
            Let's create something special.
          </MaskedLine>
        </h2>
        <Reveal delay={0.25}>
          <p className="text-neutral-400 mt-8 max-w-md leading-relaxed text-sm sm:text-base">
            Have a project in mind? Let's turn your ideas into a powerful online presence.
          </p>
          <button
            data-testid="final-cta-contact-btn"
            onClick={() => go("/contact")}
            className="group mt-10 inline-flex items-center gap-2 text-neutral-100 text-lg font-medium border-b border-white/30 pb-1.5 hover:border-white transition-colors duration-300"
          >
            Get in Touch
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
